export default __webpack_public_path__ + "static/devops-illustration@2x-aeb1ffdbb49112f7e3abaefb8aca26e9.jpg";